import { forwardRef, useEffect, useImperativeHandle, useState } from 'react'

import { BankDetailsFormControls, bankDetailsControls } from 'app/components/common/bankDetails'
import { useBankDetailsBikCheking } from 'app/dataProviders/account/bankDetails/hooks/useBankDetailsBikCheking'
import PlainFieldset from 'app/common/ui-next/plain-fieldset'

import styles from './BankControls.scss'


export { bankDetailsControls }

export type BankControlsHandle = {
  updateBankDetails: () => void
}

type Props = {
  loading: boolean
  disabled: boolean
  onModified: (modified: boolean) => void
}

export const BankControls = forwardRef<BankControlsHandle, Props>(({
  loading,
  disabled,
  onModified,
}, ref) => {
  const [modified, setModified] = useState(false)

  useEffect(() => {
    onModified(modified)
  }, [modified]) // eslint-disable-line react-hooks/exhaustive-deps

  const {
    bikRequestAndValidate,
    updateBankDetails,
    bankDetailsProps,
    bankDetailsLoading,
    bikError,
    formStateHandler,
    corrAccountLength,
  } = useBankDetailsBikCheking({ onModified: setModified })

  useImperativeHandle(ref, () => {
    return {
      updateBankDetails() {
        if (modified) {
          updateBankDetails(bankDetailsProps)
        }
      },
    }
  }, [updateBankDetails, bankDetailsProps, modified])

  return (
    <PlainFieldset legend="Банковские реквизиты" strong>
      <BankDetailsFormControls
        className={styles.form}
        bankDetailsProps={bankDetailsProps}
        loading={bankDetailsLoading || loading}
        disabled={disabled}
        onChangeValue={formStateHandler}
        onBikRequestAndValidate={bikRequestAndValidate}
        bikErrorText={bikError}
        corrAccountLength={corrAccountLength}
      />
    </PlainFieldset>
  )
})
